"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useBannerSizeCode;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

function useWidth() {
  var theme = (0, _styles.useTheme)();
  var keys = (0, _toConsumableArray2.default)(theme.breakpoints.keys).reverse();
  return keys.reduce(function (output, key) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || 'xs';
}

function useBannerSizeCode(sizes) {
  var width = useWidth();

  var bannerSizeCode = _react.default.useMemo(function () {
    return sizes[width] || null;
  }, [sizes, width]);

  return bannerSizeCode;
}